import type { EmailAttachment } from "@/components/shared/single-email-modal";
import { toast } from "sonner";

export async function fetchAttachmentsWithProgress<TId>(
  ids: TId[],
  downloadFn: (id: TId) => Promise<EmailAttachment>,
  onProgress: (done: number, total: number) => void,
): Promise<EmailAttachment[]> {
  if (ids.length === 0) return [];

  onProgress(0, ids.length);

  const results = await Promise.allSettled(
    ids.map(async (id, idx) => {
      const doc = await downloadFn(id);
      onProgress(idx + 1, ids.length);
      return doc;
    }),
  );

  const successful = results
    .filter(
      (r): r is PromiseFulfilledResult<EmailAttachment> =>
        r.status === "fulfilled",
    )
    .map((r) => r.value);

  const failedCount = results.filter((r) => r.status === "rejected").length;
  if (failedCount > 0) {
    toast.warning(`${failedCount} document(s) could not be downloaded`);
  }

  return successful;
}
